// NOTE: This is very hacky, but the only viable option I could come up with.
// The el-select container will teleport a scrollable Element to the body of the page, thus it is hard to find this element
// The solution here is to use an el-option-group with this directive.
// The el-option group will be rendered inside the scrollable element, we then select the parent of the parent to find the scroll container.
// i.e.   el-option-group(v-lazy-load="lazyLoadOption")
import { throttle } from "lodash";

function handleScroll(dom: Element, callBack: Function) {
  const scrollBottom = dom.scrollTop + dom.clientHeight;

  if (dom.scrollHeight - scrollBottom <= 40) {
    callBack();
  }
}

const selectElement = (el) => {
  const scrollContainer = el.parentElement.parentElement;
  return scrollContainer;
};

export default {
  mounted: (el, binding) => {
    const scrollContainer = selectElement(el);

    // Scroll event listener
    const scroll = throttle(
      handleScroll.bind(null, scrollContainer, binding.value),
      500,
    );
    scrollContainer.addEventListener("scroll", scroll);
  },

  unmounted: (el, binding, vnode, prevVnode) => {
    const scrollContainer = selectElement(el);
    scrollContainer.removeEventListener("scroll", scroll);
  },
};

export interface ScrollOption {
  distance: number;
  loadData: () => void;
}
